import { REVIEWS_SLIDER_SETTINGS } from 'shared/constants/slider';
import { CustomSlider } from '../Slider';
import { SliderItem } from '../SliderItem';
import * as style from './GuideItem.css';
import { Responsive, useDeviceType } from '@cian/ui-kit';
import classNames from 'classnames';

interface IGuideItemProps {
  step: number;
  title: string;
  slider: {
    image: string;
    title: string;
    notice: string;
    link: string;
  }[];
}

export const GuideItem: React.FC<IGuideItemProps> = ({ step, title, slider }) => {
  const device = useDeviceType();

  return (
    <div
      className={classNames(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title-container']}>
        <div className={style['number']}>
          <Responsive phone tablet>
            Шаг{' '}
          </Responsive>
          {step}
        </div>
        <h2 className={style['title']}>{title}</h2>
      </div>
      <div className={style['slider']}>
        <CustomSlider className={style['low-slider']} {...REVIEWS_SLIDER_SETTINGS}>
          {slider.map((item, index) => (
            <SliderItem {...item} key={index} />
          ))}
        </CustomSlider>
      </div>
    </div>
  );
};
